export const CREATE_SERVICE_REQUEST = 'CREATE_SERVICE_REQUEST';

export const UPDATE_SERVICE_REQUEST = 'UPDATE_SERVICE_REQUEST';

export const DELETE_SERVICE_REQUEST = 'DELETE_SERVICE_REQUEST';

